"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PosTypeEnum_1 = require("../../window/model/PosTypeEnum");

var WindowStateEnum_1 = require("../../window/model/WindowStateEnum");

var SimulatedColumn_1 = require("./SimulatedColumn");

var SimulatedKpiValueDTO_1 = require("./SimulatedKpiValueDTO");

var ForecastSimulationTreeDataDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationTreeDataDTO, _DomainObject_1$Domai);

  /**
   * @param entityName
   * @param originId
   * @param dummy
   * @param windowId
   * @param productExtId
   * @param name
   * @param sku
   * @param windowWFState
   * @param store
   * @param startWeekDate
   * @param endWeekDate
   * @param daysValid
   * @param promoPriceLevel
   * @param promoDiscount
   * @param secondaryPlacement
   * @param leafletFee
   * @param supplierCurrency
   * @param posType
   * @param windowTypeId
   * @param windowName
   * @param regularPrice
   * @param promoPrice
   * @param promoVolume
   * @param posMechanics
   * @param posMarginImpactTheoretical
   * @param purchasePrice
   * @param unitBackDiscount
   * @param vaValue
   * @param kpiValues
   */
  function ForecastSimulationTreeDataDTO(entityName, originId, dummy, windowId, productExtId, //
  name, sku, windowWFState, store, startWeekDate, endWeekDate, daysValid, promoPriceLevel, promoDiscount, secondaryPlacement, leafletFee, supplierCurrency, posType, filterFlags, //
  windowTypeId, windowName, regularPrice, promoPrice, promoVolume, posMechanics, posMarginImpactTheoretical, purchasePrice, unitBackDiscount, vaValue, //
  kpiValues) {
    var _this;

    _classCallCheck(this, ForecastSimulationTreeDataDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationTreeDataDTO).call(this));
    _this.entityName = entityName;
    _this.originId = originId;
    _this.dummy = dummy;
    _this.windowId = windowId;
    _this.productExtId = productExtId;
    _this.name = name;
    _this.sku = sku;
    _this.windowWFState = windowWFState;
    _this.store = store;
    _this.startWeekDate = startWeekDate;
    _this.endWeekDate = endWeekDate;
    _this.daysValid = daysValid;
    _this.promoPriceLevel = promoPriceLevel;
    _this.promoDiscount = promoDiscount;
    _this.secondaryPlacement = secondaryPlacement;
    _this.leafletFee = leafletFee;
    _this.supplierCurrency = supplierCurrency;
    _this.posType = posType;
    _this.filterFlags = filterFlags;
    _this.windowTypeId = windowTypeId;
    _this.windowName = windowName;
    _this.regularPrice = regularPrice;
    _this.promoPrice = promoPrice;
    _this.promoVolume = promoVolume;
    _this.posMechanics = posMechanics;
    _this.posMarginImpactTheoretical = posMarginImpactTheoretical;
    _this.purchasePrice = purchasePrice;
    _this.unitBackDiscount = unitBackDiscount;
    _this.vaValue = vaValue;
    _this.kpiValues = kpiValues;
    return _this;
  }

  return ForecastSimulationTreeDataDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationTreeDataDTO = ForecastSimulationTreeDataDTO;

ForecastSimulationTreeDataDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastSimulationTreeDataDTO.name);
  return {
    entityName: builder.str('entityName'),
    originId: builder.opt(builder.str('originId')),
    dummy: builder.opt(builder.bool('dummy')),
    windowId: builder.opt(builder.str('windowId')),
    productExtId: builder.opt(builder.str('productExtId')),
    //
    name: builder.opt(builder.str('name')),
    sku: builder.opt(builder.num('sku')),
    windowWFState: builder.opt(builder.senum('windowWFState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    store: builder.opt(builder.str('store')),
    startWeekDate: builder.opt(builder.date('startWeekDate', DateParser_1.DateParser.ISO_PATTERN)),
    endWeekDate: builder.opt(builder.date('endWeekDate', DateParser_1.DateParser.ISO_PATTERN)),
    daysValid: builder.opt(builder.num('daysValid')),
    promoPriceLevel: builder.opt(builder.num('promoPriceLevel')),
    promoDiscount: builder.opt(builder.bigNum('promoDiscount')),
    secondaryPlacement: builder.opt(builder.num('secondaryPlacement')),
    leafletFee: builder.opt(builder.num('leafletFee')),
    supplierCurrency: builder.opt(builder.str('supplierCurrency')),
    posType: builder.opt(builder.senum('posType', PosTypeEnum_1.PosTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.PosType)),
    filterFlags: builder.opt(builder.listOf(builder.str('filterFlags'))),
    //
    windowTypeId: builder.opt(builder.obj('windowTypeId', SimulatedColumn_1.SimulatedColumnString.schema, SimulatedColumn_1.SimulatedColumnString.fromDataDict)),
    windowName: builder.opt(builder.obj('windowName', SimulatedColumn_1.SimulatedColumnString.schema, SimulatedColumn_1.SimulatedColumnString.fromDataDict)),
    regularPrice: builder.opt(builder.obj('regularPrice', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    promoPrice: builder.opt(builder.obj('promoPrice', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    promoVolume: builder.opt(builder.obj('promoVolume', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    posMechanics: builder.opt(builder.obj('posMechanics', SimulatedColumn_1.SimulatedColumnString.schema, SimulatedColumn_1.SimulatedColumnString.fromDataDict)),
    posMarginImpactTheoretical: builder.opt(builder.obj('posMarginImpactTheoretical', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    purchasePrice: builder.opt(builder.obj('purchasePrice', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    unitBackDiscount: builder.opt(builder.obj('unitBackDiscount', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    vaValue: builder.opt(builder.obj('vaValue', SimulatedColumn_1.SimulatedColumnBigNum.schema, SimulatedColumn_1.SimulatedColumnBigNum.fromDataDict)),
    kpiValues: builder.opt(builder.smap(builder.obj('kpiValues', SimulatedKpiValueDTO_1.SimulatedKpiValueDTO.schema, SimulatedKpiValueDTO_1.SimulatedKpiValueDTO.fromDataDict)))
  };
}();

ForecastSimulationTreeDataDTO.dataOrder = [ForecastSimulationTreeDataDTO.schema.entityName.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.originId.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.dummy.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.windowId.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.productExtId.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.name.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.sku.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.windowWFState.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.store.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.startWeekDate.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.endWeekDate.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.daysValid.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.promoPriceLevel.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.promoDiscount.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.secondaryPlacement.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.leafletFee.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.supplierCurrency.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.posType.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.filterFlags.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.windowTypeId.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.windowName.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.regularPrice.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.promoPrice.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.promoVolume.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.posMechanics.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.posMarginImpactTheoretical.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.purchasePrice.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.unitBackDiscount.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.vaValue.simpleNameKey(), ForecastSimulationTreeDataDTO.schema.kpiValues.simpleNameKey()];
var ForecastSimulationRowFilterEnum;

(function (ForecastSimulationRowFilterEnum) {
  ForecastSimulationRowFilterEnum["hasWaitingToAcceptSimulation"] = "hasWaitingToAcceptSimulation";
  ForecastSimulationRowFilterEnum["hasRejectedSimulation"] = "hasRejectedSimulation";
})(ForecastSimulationRowFilterEnum = exports.ForecastSimulationRowFilterEnum || (exports.ForecastSimulationRowFilterEnum = {}));